module.exports = __webpack_public_path__ + "assets/zap-dynamic.1ae4a17f.svg";